import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import LoadingSpinner from '../components/LoadingSpinner'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify'
import BankCards from '../components/BankCards'

const AccountAggregatorDetails = () => {
    const{id}=useParams()
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
   const userId= queryParams.get("userId")

console.log(userId)
    const[reports,setReports]=useState([])
    const [loading,setLoading]=useState(false)
    const fetchReports = async () => {
      try {
          setLoading(true)
        const response = await axiosInstance.get(`/account-aggregator/get-fi-request/${id}`);
       
        setLoading(false)
        setReports(response.data.data); // Set the user bank data
      } catch (error) {
          setLoading(false)
        toast.error(error.response.data.message);
      }
    };

    useEffect(()=>{
      if(id)
      fetchReports()
  },[])
  return (
    <div>
      {loading&&<LoadingSpinner />}
      <h2 className='m-4 font-bold'>Aggregator Reports</h2>
      <div className="space-4 mx-4">
   
    
        {/* Session ID */}
        <div className="bg-white rounded-lg shadow-md p-6">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    {/* Session ID */}
    <div className="flex flex-col space-y-2">
      <span className="text-sm font-medium text-gray-600">Session ID</span>
      <p className="text-lg font-semibold text-gray-900 break-all">{reports.sessionId}</p>
    </div>

    {/* Transaction ID */}
    <div className="flex flex-col space-y-2">
      <span className="text-sm font-medium text-gray-600">Transaction ID</span>
      <p className="text-lg font-semibold text-gray-900 break-all">{reports.txnId}</p>
    </div>
  </div>

  {/* Optionally, add a button or additional content */}

</div>

{reports.banks&&<BankCards bankData={reports.banks} userId={userId} consentHandleId={reports.consentHandleId}
sessionId={reports.sessionId}
id={id}
cusName={reports.name}
fetchReports={fetchReports}
/>}
</div>
</div>
  )
}

export default AccountAggregatorDetails